import columnTypes from '../columnTypes.js';
import types from '../types.js';

const udmTables = [
  {
    key: 'udm-granular-page',
    name: 'UDM Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'SharePath',
        rename: 'Asset',
        type: types.text,
      },
      {
        source: 'ProtocolName',
        rename: 'Protocol',
        type: types.text,
      },
      {
        source: 'MostRecentActivityDate',
        rename: 'Last Activity Date',
        type: types.date,
      },
      {
        source: 'ProposedOwnerName',
        rename: 'Proposed Owner Name',
        type: types.text,
      },
      {
        source: 'FirstDivisionName',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'TotalSubfolderCount',
        rename: 'Total Folders',
        type: types.number,
      },
      {
        source: 'TotalOpenFolders',
        rename: 'Open Folders',
        type: types.number,
      },
      {
        source: 'ExcessiveAccess',
        rename: 'Excessive Access',
        type: types.number,
      },
      {
        source: 'RiskLevel',
        rename: 'Risk Level',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'TotalRiskInstances',
        rename: 'Total Sensitive Data Instances',
        type: types.number,
      },
      {
        source: 'ProposedOwner',
        rename: 'Proposed Owner',
        type: types.text,
      },
      {
        source: 'ProposedOwnerReason',
        rename: 'Proposed Owner Reason',
        type: types.text,
      },
      {
        source: 'BRID',
        rename: 'Employee ID',
        type: types.number,
      },
      {
        source: 'SecondDivisionName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'TotalSize',
        rename: 'Size',
        type: types.number,
      },
      {
        source: 'UniqueOpenFolders',
        rename: 'Unique Folders',
        type: types.number,
      },
      {
        source: 'FoldersWithDirectUserPermission',
        rename: 'Direct User',
        type: types.number,
      },
      {
        source: 'FoldersWhereUsersHaveFullControl',
        rename: 'User Full',
        type: types.number,
      },
      {
        source: 'FoldersWhereGroupsHaveFullControl',
        rename: 'Groups Full',
        type: types.number,
      },
      {
        source: 'RiskScore',
        rename: 'Risk Rating',
        type: types.number,
      },
      {
        source: 'ReportDate',
        rename: 'Report Date',
        type: types.date,
      },
      {
        source: 'NumberOfObjects',
        rename: '# Of Objects',
        type: types.number,
      },
      {
        source: 'UseCase',
        rename: 'Use Case',
        type: types.text,
      },
      {
        source: 'HostName',
        rename: 'Host Name',
        type: types.text,
      },
      {
        source: 'ServerType',
        rename: 'Server Type',
        type: types.text,
      },
      {
        source: 'AllocatedQuota',
        rename: 'Allocated Quota',
        type: types.number,
      },
      {
        source: 'RemainingQuota',
        rename: 'Available Quota',
        type: types.number,
      },
      {
        source: 'OwnershipDetermination',
        rename: 'Ownership Determination',
        type: types.text,
      },
      {
        source: 'DFSPath',
        rename: 'DFS Path',
        type: types.text,
      },
      {
        source: 'OpenObjects',
        rename: 'Open Objects',
        type: types.number,
      },
      {
        source: 'ExcessiveObjects',
        rename: 'Excessive Objects',
        type: types.number,
      },
      {
        source: 'NonStandardObjects',
        rename: 'Non-Standard objects',
        type: types.number,
      },
      {
        source: 'LastScannedDate',
        rename: 'Last Scan Date',
        type: types.date,
      },
      {
        source: 'NextScheduledDate',
        rename: 'Next Scheduled Date',
        type: types.date,
      },
      {
        source: 'CollectionRule',
        rename: 'Collection Rule',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'FilersAndSharesId',
        rename: 'FilersAndSharesId',
      },
      {
        source: 'NoRiskInstances',
        rename: 'No Risk Sensitive',
        type: types.number,
      },
      {
        source: 'LowRiskInstances',
        rename: 'Low Risk Sensitive',
        type: types.number,
      },
      {
        source: 'MediumRiskInstances',
        rename: 'Medium Risk Sensitive',
        type: types.number,
      },
      {
        source: 'HighRiskInstances',
        rename: 'High Risk Sensitive',
        type: types.number,
      },
    ],
  },
];

export default [...udmTables];
